export default __webpack_public_path__ + "static/media/ubuntu.694b644d.svg";